import React from 'react';

// INNER IMPORTS
import { AdminPins } from '../AdminPins';

const Eventes = () => {
    return (
        <div>
            <AdminPins
                query={{type: 'liveMusic'}}
            />
        </div>
    )

};
export default Eventes;


// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/Events/AdminEvents.js